module.exports = __webpack_public_path__ + "img/Image (1).d0276cbc.png";